import React from 'react';
import PropTypes from 'prop-types';

import './WoWLevelingRankPicker.sass';

import {injectIntl} from 'react-intl';
import withMediaQueries from '../../../../containers/withMediaQueries/withMediaQueries';
import VariableStepRange from '../../../controls/variableStepRange/VariableStepRange';
import RestrictedNumberInput from '../../../controls/restrictedNumberInput/RestrictedNumberInput';

@injectIntl
@withMediaQueries({collapsed: '(max-width: 767px)'}, {collapsed: false})
export default class WoWLevelingRankPicker extends React.PureComponent {
  static describeRank = rank => rank.toString();

  static minValue = 1;
  static maxValue = 120;

  static getDefaultValue = () => [15, 100];

  static marks = {
    1: '1',
    30: '30',
    60: '60',
    70: '70',
    80: '80',
    85: '85',
    90: '90',
    100: '100',
    110: '110',
    120: '120'
  };

  static multipliers = [{from: 1, to: 10, by: 1/9}, {from: 10, to: 60, by: 1/5}, {from: 60, to: 80, by: 1/2}, {from: 90, to: 120, by: 1/2}];

  render() {
    const {intl, collapsed, value, onChange} = this.props;

    return (
      <div>
        <div className="range-inputs">
          <div className="range-inputs__item">
            <RestrictedNumberInput
              label={intl.formatMessage({id: 'section.product.level'})}
              min={WoWLevelingRankPicker.minValue}
              max={WoWLevelingRankPicker.maxValue}
              value={value[0]}
              onChange={newValue => onChange([
                newValue,
                value[1]
              ])}
            />
          </div>

          <div className="range-inputs__divider"/>

          <div className="range-inputs__item">
            <RestrictedNumberInput
              label={intl.formatMessage({id: 'section.product.wanted'})}
              min={WoWLevelingRankPicker.minValue}
              max={WoWLevelingRankPicker.maxValue}
              value={value[1]}
              onChange={newValue => onChange([
                value[0],
                newValue
              ])}
            />
          </div>
        </div>

        {!collapsed && (
          <div className="slider">
            <VariableStepRange
              className="rc-slider-wow-leveling"
              step={1}
              min={WoWLevelingRankPicker.minValue}
              max={WoWLevelingRankPicker.maxValue}
              multipliers={WoWLevelingRankPicker.multipliers}
              marks={WoWLevelingRankPicker.marks}
              value={value}
              onChange={onChange}
            />
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/productVariants/rankPickers/wowLeveling/WoWLevelingRankPicker.js